export class Constants {
    public static MIN_COLUMN_WIDTH : number = 60; 
    public static MAX_COLUMN_WIDTH : number = 500; 
    public static CALC_COLUMN_LIMIT : number = 100; 
    
    // EVENTS
    public static EVENT_NAMESPACE = 'CFGRID';
    public static EVENT_CLICK = 'click.' + Constants.EVENT_NAMESPACE;
    public static EVENT_MOUSEOVER = 'mouseover.' + Constants.EVENT_NAMESPACE;
    public static EVENT_MOUSEOUT = 'mouseout.' + Constants.EVENT_NAMESPACE;
    public static EVENT_MOUSEDOWN = 'mousedown.' + Constants.EVENT_NAMESPACE;
    public static EVENT_MOUSEUP = 'mouseup.' + Constants.EVENT_NAMESPACE;
    public static EVENT_KEYDOWN = 'keydown.' + Constants.EVENT_NAMESPACE;
    public static EVENT_SCROLL = 'scroll.' + Constants.EVENT_NAMESPACE;
    public static EVENT_DBLCLICK = 'dblclick.' + Constants.EVENT_NAMESPACE;
    public static EVENT_MOUSEMOVE = 'mousemove.' + Constants.EVENT_NAMESPACE;

    public static readonly CLASS_PREFIX = 'cf-grid';
    //FOOTER
    public static readonly FOOTER_CLASS_PREFIX = Constants.CLASS_PREFIX + '-footer';
    // PAGING
    public static readonly FOOTER_CLASS_PAGING = Constants.FOOTER_CLASS_PREFIX + '-paging';
    public static readonly FOOTER_CLASS_PAGESIZE = Constants.FOOTER_CLASS_PAGING + '-pagesize';
    public static readonly FOOTER_CLASS_PAGESIZE_CURRENT = Constants.FOOTER_CLASS_PAGESIZE + '-current';
    public static readonly FOOTER_CLASS_PAGESIZE_OPTIONSWRAPPER = Constants.FOOTER_CLASS_PAGESIZE + '-options';
    public static readonly FOOTER_CLASS_PAGESIZE_OPTIONSWRAPPER_VISIBLE = Constants.FOOTER_CLASS_PAGESIZE_OPTIONSWRAPPER + '-visible';
    public static readonly FOOTER_CLASS_PAGESIZE_OPTIONSWRAPPER_HIDDEN = Constants.FOOTER_CLASS_PAGESIZE_OPTIONSWRAPPER + '-hidden';
    public static readonly FOOTER_CLASS_PAGESIZE_OPTION = Constants.FOOTER_CLASS_PAGESIZE + '-option';
    public static readonly FOOTER_CLASS_PAGESIZE_OPTION_ACTIVE = Constants.FOOTER_CLASS_PAGESIZE_OPTION + '-active';
    public static readonly FOOTER_CLASS_PAGES = Constants.FOOTER_CLASS_PAGING + '-pages';
    public static readonly FOOTER_CLASS_PAGES_DISABLED = Constants.FOOTER_CLASS_PAGES + '-disabled';
    public static readonly FOOTER_CLASS_PAGE = Constants.FOOTER_CLASS_PAGES + '-page';
    public static readonly FOOTER_CLASS_PAGE_ACTIVE = Constants.FOOTER_CLASS_PAGE + '-active';
    public static readonly FOOTER_CLASS_PAGE_DISABLED = Constants.FOOTER_CLASS_PAGE + '-disabled';
    public static readonly FOOTER_CLASS_PAGE_START = Constants.FOOTER_CLASS_PAGE + '-start';
    public static readonly FOOTER_CLASS_PAGE_END = Constants.FOOTER_CLASS_PAGE + '-end';
    public static readonly FOOTER_CLASS_PAGE_PREVIOUS = Constants.FOOTER_CLASS_PAGE + '-previous';
    public static readonly FOOTER_CLASS_PAGE_NEXT = Constants.FOOTER_CLASS_PAGE + '-next';

    // ROW
    public static readonly CLASS_ROW = Constants.CLASS_PREFIX + '-row';
    public static readonly CLASS_ROW_SELECTED = Constants.CLASS_ROW + '-selected';
    public static readonly CLASS_DUMMY_ROW = Constants.CLASS_PREFIX + '-dummy-row';

    // FILLCOLUMN
    public static readonly CLASS_CELL_FILLCOLUMN = Constants.CLASS_PREFIX + '-fillcolumn';
    
    // INLINE EDITING
    public static readonly CLASS_ISEDITING = 'is-editing';
    public static readonly CLASS_EDITMODE_SINGLE = 'editmode-single';
    public static readonly CLASS_EDITMODE_MULTIPLE = 'editmode-multiple';
    public static readonly CLASS_CANADD = 'can-add';
    public static readonly CLASS_ROW_IN_EDIT = 'row-in-editing';
    public static readonly CLASS_GRID_DISABLED = 'disabled';
    public static readonly ROLE_CELL = "gridcell";

    public static readonly CLASS_ROW_BUTTON = Constants.CLASS_ROW + '-button';
    public static readonly CLASS_ROW_EDITBUTTON = Constants.CLASS_ROW + '-editButton';
    public static readonly CLASS_ROW_DELETEBUTTON = Constants.CLASS_ROW + '-deleteButton';
    public static readonly CLASS_ROW_SAVEBUTTON = Constants.CLASS_ROW + '-saveButton';
    public static readonly CLASS_ADDBUTTON = Constants.CLASS_PREFIX + '-addButton';

    // COLUMN-RESIZER
    public static readonly CLASS_RESIZER = Constants.CLASS_PREFIX + '-resizer';

    // VERTICAL GRID-RESIZER
    public static readonly CLASS_BOTTOM_BORDER_RESIZER = 'bottom-border-resizer';
    public static readonly CLASS_VERTICAL_RESIZE_CURSOR = 'vertical-resize-cursor';

    // SUMMARY ROW
    public static readonly FOOTER_CLASS_SUMMARYROW = Constants.FOOTER_CLASS_PREFIX + '-summaryrow';

    // DATA ATTRIBUTES
    public static readonly DATA_ATTRIBUTE_ROW_ID = 'rowid';
    public static readonly DATA_ATTRIBUTE_IS_NULL = 'isnull';
    public static readonly DATA_ATTRIBUTE_COLUMN = 'column';
    public static readonly DATA_ATTRIBUTE_LOCATOR = 'locator';
    public static readonly DATA_ATTRIBUTE_SHOWS_TOOLTIP = 'showsTooltip';
}